import React, { useState } from 'react';
import _t from 'counterpart';
import { CFormGroup, CCard, CCardHeader, CCardBody, CCardTitle, CCol, CRow } from '@coreui/react';
import CustomSelect from '../../components/CustomSelect';
import InputHeaderNoButton from '../../components/InputHeaderNoButton';
import CoperatoIntegration from './CoperatoIntegration';
import VoisoIntegration from './VoisoIntegration';
import QueryDataRenderer from '../../components/QueryDataRenderer';
import { useGetSetting, useSetSetting } from './hooks';
import ButtonWithLoader from '../../components/ButtonWithLoader';
import { useQueryClient } from 'react-query';
import toast from 'react-hot-toast';
import VoicespinIntegration from './VoicespinIntegration';
import CommpeakIntegration from './CommpeakIntegration';

const VoipIntegration = () => {
  const providersOptions = [
    { label: 'Disabled', value: '' },
    { label: 'Coperato', value: 'coperato' },
    { label: 'Voiso', value: 'voiso' },
    { label: 'VoiceSpin', value: 'voicespin' },
    { label: 'CommPeak', value: 'commpeak' },
  ];

  const [provider, setProvider] = useState<{ label: string; value: string }>(providersOptions[0]);

  const setSettingsMutation = useSetSetting();

  const queryClient = useQueryClient();

  const voipProviderQuery = useGetSetting('VOIP_PROVIDER', 'voip-provider', {
    onSuccess: (provider: string) => {
      if (provider === '') {
        setProvider(providersOptions[0]);
      }
      if (provider === 'coperato') {
        setProvider(providersOptions[1]);
      }
      if (provider === 'voiso') {
        setProvider(providersOptions[2]);
      }
      if (provider === 'voicespin') {
        setProvider(providersOptions[3]);
      }
      if (provider === 'commpeak') {
        setProvider(providersOptions[4]);
      }
    },
    refetchOnWindowFocus: false,
  });

  const handleProviderChanged = (provider: any) => {
    setProvider(provider);
  };

  const onProviderChange = () => {
    queryClient.invalidateQueries(['voip-provider-content']);
  };

  const isLoading = voipProviderQuery.isFetching;
  const isError = Boolean(voipProviderQuery.error) && !isLoading;

  const disableVoipMutationCall = () => {
    setSettingsMutation.mutate(
      { key: 'VOIP_PROVIDER', value: '' },
      {
        onSuccess: () => {
          toast.success(_t('integrations.voip-disabled'));
          onProviderChange();
        },
      }
    );
  };

  return (
    <CCol md={12}>
      <CCard>
        <CCardHeader>
          <CCardTitle>{_t('integrations.voip-provider')}</CCardTitle>
        </CCardHeader>
        <CCardBody>
          <QueryDataRenderer isError={isError} isLoading={isLoading} onRefetch={voipProviderQuery.refetch}>
            <CFormGroup>
              <InputHeaderNoButton labelText={_t('providers.label')} />
              <CustomSelect
                value={provider}
                onChange={handleProviderChanged}
                options={providersOptions}
                menuPortalTarget={document.body}
              />
            </CFormGroup>
            {provider.value === 'coperato' && <CoperatoIntegration onChange={onProviderChange} />}
            {provider.value === 'voiso' && <VoisoIntegration onChange={onProviderChange} />}
            {provider.value === 'voicespin' && <VoicespinIntegration onChange={onProviderChange} />}
            {provider.value === 'commpeak' && <CommpeakIntegration onChange={onProviderChange} />}
            {provider.value === '' && (
              <CRow>
                <CCol md={12} className="d-flex justify-content-end">
                  <ButtonWithLoader
                    isLoading={setSettingsMutation.isLoading}
                    onClick={disableVoipMutationCall}
                    buttonColor="primary"
                    spinnerColor="secondary"
                    title={_t('action.save')}
                    className="btn-md"
                    showText={false}
                  />
                </CCol>
              </CRow>
            )}
          </QueryDataRenderer>
        </CCardBody>
      </CCard>
    </CCol>
  );
};

export default VoipIntegration;
